import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { IOrchestrationTargetingRuleDto } from 'src/app/models/orchestrations';
import { OrchestrationOrchestrationTargetingRuleService } from 'src/app/services/orchestration/orchestration-orchestration-targeting-rule.service';
import { BaseComponent } from 'src/app/shared/base.component';
import { TenantUIService } from '../../../tenant-ui.service';
import { OrchestrationOrchestrationService } from 'src/app/services/orchestration/orchestration-orchestration.service';
import { MenuItem, MessageService } from 'primeng/api';

@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss']
})
export class CampaignsComponent extends BaseComponent implements OnInit {

  activeLabel: string = "Showing All Items";
  campaignIcon: string = "fal fa-command";
  orchestrationTargetingRules: IOrchestrationTargetingRuleDto[] = [];

  items: MenuItem[];

  triModeValue: any;
  searchValue: string;

  changedValue: boolean = false;
  sortNameOrder: boolean = false;
  sortChannelOrder: boolean = false;
  lastSortOrder: string;
  searchFilter: string;

  constructor(private orchestrationTargetingRuleService: OrchestrationOrchestrationTargetingRuleService,
      public tenantService: TenantUIService,
      private orchestrationService: OrchestrationOrchestrationService,
      private messageService: MessageService) 
    {
      super();
    }

  async ngOnInit() {

    await this.loadSortMenu();
    await this.orchestrationService.getAllOrchestrations();
    await this.orchestrationTargetingRuleService.getAllOrchestrationTargetingRules();

    await this.loadAllOrchestrationTargetingRules();
  }

  async loadSortMenu() {
  
    this.items = [
      { 
        label: 'Sort by Name', icon: 'fa-light fa-rotate', command: () => {
          this.sortNameOrder = !this.sortNameOrder;
          this.sortOrchestrationName();
          this.lastSortOrder = "name";
      }},
      { 
        label: 'Sort by Channel', icon: 'fa-light fa-rotate', command: () => {
          this.sortChannelOrder = !this.sortChannelOrder;
          this.sortChannelType();
          this.lastSortOrder = "channel";
      }}
    ];
  }
  
  async loadAllOrchestrationTargetingRules()
  {
    let tenantName = this.tenantService.selectedTenant.tenantName;

      switch(this.triModeValue) {
        case true:
          {
            this.activeLabel = "Showing Active Items";
            this.orchestrationTargetingRules = 
            this.orchestrationTargetingRuleService.allOrchestrationTargetingRule.filter(t=> t.tenant == tenantName && t.active);

            break
          }

        case false:
          {
            this.activeLabel = "Showing InActive Items";
            this.orchestrationTargetingRules = 
            this.orchestrationTargetingRuleService.allOrchestrationTargetingRule.filter(t=> t.tenant == tenantName && !t.active);

            break
          }

        default:
          {
            this.activeLabel = "Showing All Items";
            this.orchestrationTargetingRules = 
            this.orchestrationTargetingRuleService.allOrchestrationTargetingRule.filter(t=> t.tenant == tenantName)

            break
          }
      }

      this.orchestrationTargetingRules.forEach(element=> {
        element.orchestrationName = this.orchestrationService.getOrchestrationName(element.orchestrationId);
        element.channelType = this.orchestrationService.getChannelType(element.orchestrationId);
    });
  }

  async searchFilterOrchestrations(filter: string) {
    this.searchFilter = filter;
    await this.applyFiltering();
  }

  async applyFiltering() {

    await this.loadAllOrchestrationTargetingRules();

    if(this.searchFilter) {
      this.orchestrationTargetingRules = this.orchestrationTargetingRules.filter(element=> {
        if(element.orchestrationName?.toUpperCase().includes(this.searchFilter?.toUpperCase()) 
          || element.channelType?.toUpperCase().includes(this.searchFilter?.toUpperCase())) return true;
      });
    }

    (this.lastSortOrder === "name") ? this.sortOrchestrationName() : this.sortChannelType();
  }

  async activeValueBlur($event: boolean, id: number) {

    if(this.changedValue) {
      this.updateTenantRule($event, id);
    }
  }

  async updateTenantRule($event: boolean, id: number) {
    
    this.changedValue = false;

    try {

      let rule = this.orchestrationTargetingRules.find(t=> t.id == id);
      if(rule) {
        await this.orchestrationTargetingRuleService.saveOrchestrationTargetingRuleItem(rule);
        this.messageService.add({severity:'success', summary: 'Success', detail:'Tenant Rule is updated'});
      }
    }
    catch(error)
    {
        this.messageService.add({severity:'error', summary: 'Failed', detail: error, life: 3000});
    }
  }

  async sortOrchestrationName() {
    this.orchestrationTargetingRules = (this.sortNameOrder)
    ? [...this.orchestrationTargetingRules].sort((n1, n2) => n1.orchestrationName?.toUpperCase() > n2.orchestrationName?.toUpperCase() ? 1 : -1)
    : [...this.orchestrationTargetingRules].sort((n1, n2) => n2.orchestrationName?.toUpperCase() > n1.orchestrationName?.toUpperCase() ? 1 : -1)
  }

  async sortChannelType() {
    this.orchestrationTargetingRules = (this.sortChannelOrder)
    ? [...this.orchestrationTargetingRules].sort((n1, n2) => n1.channelType?.toUpperCase() > n2.channelType?.toUpperCase() ? 1 : -1)
    : [...this.orchestrationTargetingRules].sort((n1, n2) => n2.channelType?.toUpperCase() > n1.channelType?.toUpperCase() ? 1 : -1)
  }

}
